import { ReactComponent as WhiteHeart } from 'assets/icons/white-heart.svg';

interface props {
    value?: number;
    currentBookmarked?: boolean;
    fill?: string;
}

export const CountLike = ({ value = 0, currentBookmarked = false, fill = 'white' }: props) => {
    return (
        <div
            className={'badge-heart marked'}
            style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}
        >
            <WhiteHeart fill={fill} />
            <div className="count-heart" style={{ marginLeft: 4, color: '#ffff' }}>
                {value}
            </div>
        </div>
    );
};
